export default {
  name: "snoreData",
  data: function data() {
    return {
      isCn: true,
      imgRecord1: require("../../assets/imgs/snore-record1.png"),
      imgRecord2: require("../../assets/imgs/snore-record2.png"),
      imgRecord3: require("../../assets/imgs/snore-record3.png")
    };
  },
  beforeCreate: function beforeCreate() {
    document.title = this.$t("message.snore.snoreRecord"); // 标题国际化
  },
  created: function created() {
    var lang = (navigator.language || "").toLowerCase();
    this.isCn = lang === "zh-CN".toLowerCase() || lang === "zh-TW".toLowerCase();
  }
};